import * as C from "../../../../../ui/common/CommonStyles";
import { useState } from "react";
import PopupPreview from "./components/preview";
import { useDisclosure } from "@mantine/hooks";
import { PopupPreviewInfo } from "./types";
import PopupForm from "./components/popupForm";

export default function PopupRegister() {
  const [opened, { open, close }] = useDisclosure(false);
  const [previewInfo, setPreviewInfo] = useState<PopupPreviewInfo | null>(null);

  return (
    <div>
      <C.TitleBox>
        <div className="title">팝업 등록</div>
      </C.TitleBox>
      <PopupForm open={open} setPreviewInfo={setPreviewInfo} />
      {opened && (
        <PopupPreview opened={opened} close={close} previewInfo={previewInfo} />
      )}
    </div>
  );
}
